<template>
  <input ref="field" v-model="input" type="text" :placeholder="placeholder" />
</template>

<script>
export default {
  name: 'FireInput',

  props: {
    value: {
      type: String || null,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['change'],

  data() {
    return {
      input: '',
      loaded: false,
    };
  },

  watch: {
    input(data) {
      if (!this.loaded) {
        return;
      }
      this.$emit('change', data);
    },
  },
  created() {
    this.input = this.value || '';
    setTimeout(() => {
      this.loaded = true;
    }, 100);
  },
  mounted() {
    if (this.autoFocus && this.$refs.field) {
      this.$refs.field.focus();
    }
  },
  methods: {
    focus() {
      if (this.$refs.field) {
        this.$refs.field.focus();
      }
    },
    updateInput(value) {
      this.loaded = false;
      this.input = value;
      setTimeout(() => {
        this.loaded = true;
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
input {
  text-overflow: ellipsis;
}
</style>
